import React from "react";

import ApplicationProcedureAIR from "./ApplicationProcedureAIR";
import CareerOptionsAIR from "./CareerOptionsAIR";
import EligibilityAIR from "./EligibilityAIR";
import ObjectivesAIR from "./ObjectivesAIR";
import OutcomesAIR from "./OutcomesAIR";
import OverviewAIR from "./OverviewAIR";
import ProgramModulesAIR from "./ProgramModulesAIR";

const AIR = () => {
  return (
    <div>
      <section id="overview" className="scroll-mt-40">
        <OverviewAIR />
      </section>
      <section id="objectives" className="scroll-mt-40">
        <ObjectivesAIR />
      </section>
      <section id="eligibility" className="scroll-mt-40">
        <EligibilityAIR />
      </section>
      <section id="application-procedure" className="scroll-mt-40">
        <ApplicationProcedureAIR />
      </section>
      <section id="program-modules" className="scroll-mt-40">
        <ProgramModulesAIR />
      </section>
      <section id="career-options" className="scroll-mt-40">
        <CareerOptionsAIR />
      </section>
      <section id="outcomes" className="scroll-mt-40">
        <OutcomesAIR />
      </section>
    </div>
  );
};

export default AIR;
